<div class="table-responsive" *ngIf="leavesData.length; else noLeave">
  <div class="text-center-font">Leave Approvals</div>
  <hr style="background: red" />
  <div class="float-left">
    <button
      class="btn btn-sm btn-primary mb-1"
      (click)="bulkApproval()"
      type="button"
      [disabled]="loadingBulkApprove"
    >
      <span
        *ngIf="loadingBulkApprove"
        class="spinner-border spinner-border-sm mr-1"
      ></span
      >Bulk Approval
    </button>
  </div>
  <table class="table table-striped mb-0">
    <thead>
      <tr class="bg-primary text-white">
        <th>
          <label class="form-check-label">
            Select all<br />
            <input type="checkbox" (change)="checkUncheckAllLeave($event)" />
          </label>
        </th>
        <th>Leave Id</th>
        <th>Emp Name</th>
        <th>Applied Date</th>

        <th>Days</th>
        <th>Leave Type</th>
        <th>Action By / Date</th>
        <th>On Behalf?</th>
        <th>Reason</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody
      *ngFor="
        let data of leavesData
          | paginate
            : {
                id: 'leavepage',
                itemsPerPage: pageSize,
                currentPage: page,
                totalItems: count
              };
        let i = index
      "
    >
      <tr>
        <td>
          {{ i + 1 }}. &nbsp;&nbsp;&nbsp;
          <input
            *ngIf="data.pending > 0"
            type="checkbox"
            [(ngModel)]="data.isSelected"
          />
        </td>
        <td>
          #{{ data.lv_id }}<br />
          <a *ngIf="data.doc_attachment" href="{{ data.doc_attachment }}"
            >View Document</a
          >
        </td>
        <td>{{ data.username }}</td>
        <td>
          {{ data.applied_date | date : "dd/MM/yyyy H:mm:ss" }}
        </td>

        <td>
          <mat-chip-list aria-label="leave days">
            <mat-chip
              *ngFor="let item of data.trans"
              [color]="item.color"
              [selected]="item.color != '' ? true : false"
              >{{ item.lv_date | date : "dd/MM/yyyy" }}</mat-chip
            >
          </mat-chip-list>
        </td>

        <td>
          {{ data.lv_desc }}<br /><br />
          <span
            *ngIf="data.is_exceptional"
            style="
              padding: 7px;
              background: #f62d51;
              color: white;
              white-space: nowrap;
            "
          >
            Exceptional Request
          </span>
        </td>
        <td>
          {{ data.actionBy }}-{{ data.actionByName }}
          {{ data.actionByLname }}
          <br />
          <span *ngIf="data.actionBy">{{
            data.actionByUpdate | date : "dd/MM/yyyy  H:mm:ss"
          }}</span>
        </td>
        <td>
          {{ data.is_on_behalf == 1 ? "YES" : "NO" }} <br />{{
            data.on_behalf_created_by
          }}
        </td>
        <td>{{ data.reason }}</td>
        <td>
          <section *ngIf="data.is_rejectable; else noRejectable">
            <div
              class="btn-group btn-group-sm d-block"
              *ngIf="data.pending > 0; else approved"
            >
              <button
                type="button"
                class="btn btn-sm btn-success"
                (click)="approveRej(data, 1)"
              >
                <i class="fa fa-user-plus" aria-hidden="true"></i>
                Approve
              </button>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                (click)="approveRej(data, 2)"
              >
                <i class="fa fa-user-times" aria-hidden="true"></i>
                Reject
              </button>
            </div>
            <ng-template #approved>
              <section *ngIf="data.approved > 0; else noRejectable">
                <button
                  type="button"
                  class="btn btn-sm btn-danger"
                  (click)="approveRej(data, 3)"
                >
                  <i class="fa fa-user-times" aria-hidden="true"></i>
                  Reject
                </button>
              </section>
            </ng-template>
          </section>
          <ng-template #noRejectable>
            {{
              data.trans.length === data.pending
                ? "Pending"
                : data.trans.length == data.approved
                ? "Approved"
                : data.pending > 0
                ? "Pending"
                : data.approved > 0
                ? "Approved"
                : "Rejected"
            }}
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #noLeave>
  <div class="row">
    <div class="col-md-12 text-center">
      <h3>No leave approvals pending</h3>
    </div>
  </div>
</ng-template>
